// in src/users.js
import React, { FC } from 'react';
import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  EditButton,
} from 'react-admin';

export const EventsList: FC = (props) => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="name" label="Имя" />
      <BooleanField source="is_active" label="Активно" />
      <EditButton label="Редактировать" />
    </Datagrid>
  </List>
);
